import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EnvironmentBannerComponent } from './app/shared/components/environment-banner/environment-banner.component';


@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, EnvironmentBannerComponent],
    template:
        `
  <app-environment-banner></app-environment-banner>
    <router-outlet></router-outlet>
    `
})
export class AppComponent {

}
